


import { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { EnvoieContext } from '../../context/envoieContext/EnvoieContext';
import { addHistoryCase, getHistory } from '../../context/envoieContext/apiCalls';
import AdminSideBar from '../../components/adminSideBar/AdminSideBar';
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import TinyCartBox from '../../components/tinyCartBox/TinyCartBox';
import { currentStatusEnvois, historyCases, statusEnvois, typeEnvois } from '../../data';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import FormTextArea from '../../components/formTextArea/FormTextArea';
import './envoie.css';
import FormInput from '../../components/formInput/FormInput';

function DetailEnvoie() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [errorBox, setErrorBox] = useState("");
    const { dispatch, envoie, isFetchingGet, errorGet, historyCaseAdd, isFetchingCaseAdd, errorCaseAdd, pageNumber } = useContext(EnvoieContext);

    const [motif, setMotif] = useState("");
    const [historyCase, setHistoryCase] = useState({ nom: "Choisir un Cas", id: 0 });
    const [statusEnvoie, setStatusEnvoie] = useState("")
    const [nom, setNom] = useState("");
    const [tel1, setTel1] = useState("");
    const [description, setDescription] = useState("");

    useEffect(() => {
        getHistory(dispatch, id);
        setHistoryCase({ nom: "Choisir un Cas", id: 0 });
        setMotif('');
        setErrorBox('')
    }, [id, historyCaseAdd])

    useEffect(() => {
        if (envoie && Object.keys(envoie).length !== 0) {
            if (envoie.type === 5 && (envoie.currentStatus === 2 || envoie.currentStatus === 3)) {  // ACC or RETOUR
                setNom(envoie.Envoi.Entreprise ? envoie.Envoi.Entreprise.nom : envoie.Envoi.User.Userinfo.nom || "");
                setTel1(envoie.Envoi.Entreprise ? envoie.Envoi.Entreprise.tel1 : envoie.Envoi.User.Userinfo.tel1 || "");
            } else if ((envoie.type === 1 && envoie.Envoi.typeEnvoie !== 3) || (envoie.type === 5 && envoie.Envoi.typeEnvoie === 3)) { // pour le Ramassage
                setNom(envoie.Envoi.Entreprise ? envoie.Envoi.Entreprise.nom : envoie.Envoi.User.Userinfo.nom || "");
                setTel1(envoie.Envoi.Entreprise ? envoie.Envoi.Entreprise.tel1 : envoie.Envoi.User.Userinfo.tel1 || "");
            } else if ((envoie.type === 1 && envoie.Envoi.typeEnvoie === 3) || (envoie.type === 5 && envoie.Envoi.typeEnvoie !== 3)) { // pour la Livraison
                setNom(envoie.Envoi.nomArrived || "");
                setTel1(envoie.Envoi.tel1Arrived || "");
            }
            setDescription(envoie.Envoi.description)
        }
    }, [envoie])

    useEffect(() => {
        if (errorCaseAdd != false) {
            setErrorBox(errorCaseAdd);
        }
    }, [errorCaseAdd])

    const addHistoryCaseHandler = (e) => {
        e.preventDefault();
        if (historyCase.id === 0) {
            setErrorBox(`Vous devez Saisir un Cas`);
            return;
        }
        // if (motif.trim() == "") {
        //     setErrorBox(`Vous devez compléter le Motif `);
        //     return;
        // }
        addHistoryCase(dispatch, historyCase.id, motif, envoie.id);
    }

    return (
        <div className='container-global'>
            <AdminSideBar activeTab="envoie" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    {
                        (envoie && Object.keys(envoie).length !== 0) && (
                            <span>Action : {currentStatusEnvois.filter(item => item.id === envoie.currentStatus)[0]['nom']}-{envoie.Envoi.tracking}</span>
                        )
                    }
                </div>

                {errorBox !== "" && (<div style={{ marginBottom: "25px" }} className='box-error'>{errorBox}</div>)}

                {
                    errorGet ? <ErrorComponent error={errorGet} /> : (
                        isFetchingGet ? <LoadingComponent /> : (
                            !envoie ? <span className='no-data'>Envoie Introuvable</span> : (
                                <>
                                    <div className='cart-box' style={{ margin: "45px 0 13px" }}>
                                        <div className="title-cart" style={{ marginBottom: '12px' }}>
                                            Ajouter une Action : <br />
                                            {envoie.type && statusEnvois.filter(item => item.id === envoie.type)[0]['nom']}
                                        </div>
                                        <div className="content-cart" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                            <FormInput label='Nom' itemInput={nom} setItemInput={setNom} auth inactive />
                                            <FormInput label='Tel1' itemInput={tel1} setItemInput={setTel1} auth inactive />
                                            <FormTextArea label='Description' itemInput={description} setItemInput={setDescription} auth inactive areaH={100}/>
                                            {
                                                envoie.type === 1 ? (
                                                    <DropDownComponent data={[{ nom: "Choisir un Cas", id: 0, }, ...historyCases.filter(item => item.id !== 1 && item.id !== 3)]} itemChoisir={historyCase} setItemChoisir={setHistoryCase} deliver />
                                                ) : (
                                                    <DropDownComponent data={[{ nom: "Choisir un Cas", id: 0, }, ...historyCases.filter(item => item.id !== 4 && item.id !== 5)]} itemChoisir={historyCase} setItemChoisir={setHistoryCase} deliver />
                                                )
                                            }
                                            <FormTextArea label='Motif' itemInput={motif} setItemInput={setMotif} auth />
                                            <div className='button-deliver' style={{ textAlign: 'right' }}>
                                                <span className='add' onClick={addHistoryCaseHandler} style={isFetchingCaseAdd ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}>
                                                    {isFetchingCaseAdd ? "Ajouter ..." : "Ajouter"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        envoie?.Casehistories?.length === 0 ? <span className='no-data'>Il n'y a pas encore de données</span> : (
                                            envoie?.Casehistories?.map((item, index) => (
                                                <TinyCartBox key={index} casHistory={item} />
                                            ))
                                        )
                                    }
                                    <div className='button-deliver' style={{ textAlign: 'center' }}>
                                        <span className='retour' onClick={() => navigate(`/envois/${pageNumber}`)}>Retour</span>
                                    </div>
                                </>
                            )
                        )
                    )
                }

            </div>
        </div>
    )
}

export default DetailEnvoie
